import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import DollarPriceInput from '../';
import { EarningsCalculator, parseFloatOrFallback } from '../../EarningsCalculator';
/** DollarPriceInput w/ built-in EarningsCalculator in the `details` */ export const PriceInputWithEarnings = (_param)=>{
    var { value , productType , placeholderPrice =0 , withoutEarningsCalculator , error  } = _param, remainingDollarPriceInputProps = _object_without_properties(_param, [
        "value",
        "productType",
        "placeholderPrice",
        "withoutEarningsCalculator",
        "error"
    ]);
    return /*#__PURE__*/ React.createElement(DollarPriceInput, _extends({
        value: value,
        errorMessage: error,
        placeholder: placeholderPrice ? `${placeholderPrice}` : undefined,
        details: withoutEarningsCalculator || !productType ? undefined : /*#__PURE__*/ React.createElement(EarningsCalculator, {
            price: parseFloatOrFallback(value, placeholderPrice),
            productType: productType
        })
    }, remainingDollarPriceInputProps));
};
PriceInputWithEarnings.displayName = 'PriceInputWithEarnings';
export default PriceInputWithEarnings;
